import { Camera, Fire, FireExtinguisher, House, Lock } from '@insify/design-system/line-icons';
import { PropertyDeclarations, useWizard } from '@insify/funnel-components';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { useCommands } from '../../hooks/useCommands';
import { useContent } from '../../hooks/useContent';
import { useConditionsQuery } from '../../hooks/useQueries';

import type { PropertyDeclarationKey } from '../../models/property';

// Need to further improve after property coverages are in place
export const PropertyDeclarationPage = () => {
  const { t } = useTranslation(['common']);
  const { propertyParams } = useContent() || {};
  const [consent, setConsent] = useState<boolean | undefined>(undefined);
  const { showPreviousPage, showNextPage } = useWizard();
  const { sendCommand } = useCommands();
  const { data: { propertyDeclarations } = {} } = useConditionsQuery();

  const submit = ({ consent, declarations }: { consent: boolean; declarations: PropertyDeclarationKey[] }) => {
    void sendCommand({
      type: 'givePropertyDeclarations',
      payload: { answer: consent ? 'I have all' : 'I do not have all', declarations },
    });
    showNextPage();
  };

  if (!propertyDeclarations) {
    return <></>;
  }

  return (
    <PropertyDeclarations
      declarations={propertyDeclarations}
      value={consent}
      content={propertyParams}
      isSubmitting={false}
      icons={{
        hardMaterialsBuilding: <House />,
        hazards: <Fire />,
        fireExtinguishers: <FireExtinguisher />,
        lock: <Lock />,
        burglarAlarm: <Camera />,
      }}
      translations={{
        yes: t('common:yes'),
        no: t('common:no'),
        submit: t('common:continue'),
        back: t('common:back'),
        headerBurglarAlarm: <Trans i18nKey={'funnel:property_burglar_alarm_intro'} />,
        headerFireExtinguishers: <Trans i18nKey={'funnel:property_fire_extinguishers_intro'} />,
        headerHardMaterialsBuilding: <Trans i18nKey={'funnel:property_hard_materials_building_intro'} />,
        headerHazards: <Trans i18nKey={'funnel:property_hazards_intro'} />,
        headerLock: <Trans i18nKey={'funnel:property_Lock_intro'} />,
      }}
      eventHandlers={{
        onSubmit: submit,
        onSelectValue: (consent) => setConsent(consent),
        onBack: showPreviousPage,
      }}
    />
  );
};
